import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FaHeart } from 'react-icons/fa';

const FloatingHearts = () => {
  const [hearts, setHearts] = useState([]);

  useEffect(() => {
    const generated = Array.from({ length: 12 }).map((_, index) => ({
      id: index,
      left: Math.random() * 100,
      top: Math.random() * 100,
      size: 14 + Math.random() * 20,
      duration: 10 + Math.random() * 14,
      delay: Math.random() * 3,
    }));
    setHearts(generated);
  }, []);

  return (
    <div className="birthday-hearts-layer">
      {hearts.map((heart) => (
        <motion.div
          key={heart.id}
          className="birthday-heart-wrap"
          style={{ left: `${heart.left}%`, top: `${heart.top}%` }}
          animate={{ y: [0, -24, 0], x: [0, 8, -8, 0], scale: [1, 1.1, 1], opacity: [0.7, 1, 0.7] }}
          transition={{ duration: heart.duration, delay: heart.delay, repeat: Infinity, ease: 'easeInOut' }}
        >
          <FaHeart style={{ width: `${heart.size}px`, height: `${heart.size}px` }} />
        </motion.div>
      ))}
    </div>
  );
};

export default FloatingHearts;
